/** Local: máy dev — API qua Docker published ports hoặc chỉnh theo máy bạn. */
export const environment = {
  production: false,
  accountApiUrl: "http://account.dev-api.bmscontrols.vn",
  taskSharingApiUrl: "http://task.dev-api.bmscontrols.vn",
  apiUrl: "http://task.dev-api.bmscontrols.vn",
  uploadUrl: "http://task.dev-api.bmscontrols.vn/uploads",
  cloudUrl: "http://account.dev.bmscontrols.vn",
  itemsPerPage: 20,
};
